import React from 'react'
import { RouteComponentProps } from 'react-router-dom'

import {
  BannersDisplay,
  Box,
  Tabs,
  TabPanel,
  Tab,
  TabList,
  BannerPageWrapper,
} from '@sketch/components'
import { RouteParams } from '@sketch/modules-common'

import NotificationsListWithData from 'modules/activity/components/Notifications/NotificationsListWithData'
import { WorkspaceSidebarLayoutExtraProps } from 'modules/workspace/components/WorkspaceSidebarLayout/WorkspaceSidebarLayout'

/**
 * TYPES
 */
export type UpdatesRoutesProps = RouteComponentProps<RouteParams<'UPDATES'>>

type UpdatesViewProps = UpdatesRoutesProps & WorkspaceSidebarLayoutExtraProps

/**
 * MAIN COMPONENT
 */
export const Updates: React.FC<UpdatesViewProps> = props => {
  const { NavbarPortal, useOverrideLayoutProps } = props

  useOverrideLayoutProps({
    title: 'Updates',
  })

  return (
    <>
      <NavbarPortal>
        <Box ml={2}>
          <Tabs>
            <TabList>
              <Tab>Inbox</Tab>
              <Tab externalUrl="https://www.sketch.com/updates/">
                New in Sketch &#x2197;
              </Tab>
            </TabList>
            {/* In this specific situation we don't need to use TabPanel as we
                only have one active tab, and the content will be shown as a
                children of SplitLayout */}
            <TabPanel>{null}</TabPanel>
          </Tabs>
        </Box>
      </NavbarPortal>

      {/* Mounting the banner container to render them all */}
      <BannerPageWrapper $hideMargins="top">
        <BannersDisplay />
      </BannerPageWrapper>
      <NotificationsListWithData />
    </>
  )
}
